import React from 'react';
import {
  CustomerHeaderContainer,
  StyledDetails,
  StyledGender,
  StyledGenderContainer
} from './style';
import Icon from '../../Common/Icon';
import { StyledDiv, StyledSpan } from '../../../Theme/CommonStyled';
import { useTranslation } from 'react-i18next';
import { ProfileDataType } from '../../../Types/profile.type';
import { fixLocaleString } from '../../../Utils/common.util';

const CustomerHeader: React.FC<{ data: ProfileDataType; currency: string }> = ({
  data,
  currency
}) => {
  const { t } = useTranslation();

  return (
    <CustomerHeaderContainer>
      <StyledGenderContainer>
        <StyledGender sex={data?.sex}>
          {data?.sex && (
            <Icon
              name={`${data?.sex.toLowerCase()}-user`}
              fontSize={12}
              color="secondaryButtonText"
            />
          )}
        </StyledGender>
      </StyledGenderContainer>
      <StyledDiv fontSize={6} color="normalText" mb={5}>
        {data?.name}
      </StyledDiv>
      <StyledDiv fontSize={4} color="secondaryText" letterSpacing={2} mb={9}>
        {data?.mobile}
      </StyledDiv>
      <StyledDiv display="flex" width={'100%'} direction="rtl">
        {['registerTime', 'wallet', 'localMemberId'].map(
          (item) =>
            !!data?.[item] && (
              <StyledDetails key={item}>
                <StyledSpan mb={3} color="normalText">
                  {t(`profile.${item}`)}
                </StyledSpan>
                <StyledSpan
                  letterSpacing={item === 'localMemberId' ? '0.2rem' : 0}
                  fontSize={2}
                  color={
                    item === 'localMemberId'
                      ? 'primaryBlue'
                      : item === 'wallet'
                      ? 'secondaryGreen'
                      : 'secondaryText'
                  }>
                  {item === 'wallet'
                    ? fixLocaleString(data?.[item])
                    : data?.[item] || '-'}
                  {item === 'wallet' && !!data?.[item] && (
                    <StyledSpan mr={3}>{currency}</StyledSpan>
                  )}
                </StyledSpan>
              </StyledDetails>
            )
        )}
      </StyledDiv>
    </CustomerHeaderContainer>
  );
};

export default CustomerHeader;
